import { get, post } from "../utils/requrest.js";
// 首页 // 获取标题列表
export function getHome(param) {
  return get("website/getTitleList", param);
}

// 获取新闻列表
export function getArticleList(param) {
  return get("website/getArticleList", param);
}

// 获取留言列表
export function getMessage(param) {
  return get("website/getMessage", param);
}

// 提交合作意向
export function submitCooperation(param) {
  return post("website/submitCooperation", param);
}

// 提交留言
export function saveMessage(param) {
  return post("website/saveMessage", param);
}

// 提交留言
export function saveLoanApplication(param) {
  return post("website/saveLoanApplication", param);
}




// WEBPACK FOOTER //
// ./src/api/home.js